export default __webpack_public_path__ + "static/media/customize2.8170b3f2.webp";